'use strict';

function formatValueWithCurrency(neg, value, currency) {
    if (currency.currencyPosition === 'back') {
        return formatWithCurrencyInBack(neg, value, currency);
    } else if (currency.currencyPosition === 'front') {
        return formatWithCurrencyInFront(neg, value, currency);
    }

    return value;
}

function formatValue(qty, currency) {
    const dec = getDecimals(qty);
    return formatThousands(dec, currency) + formatDecimals(qty, dec, currency);
}

function formatValueWithMarkup(qty, currency) {
    const dec = getDecimals(qty);
    return `<span class="integer">${formatThousands(dec, currency)}</span><span class="decimal">${formatDecimals(qty, dec, currency)}</span>`;
}

function getDecimals(qty) {
    return parseInt(qty, 10) + '';
}

function formatWithCurrencyInBack(neg, value, currency) {
    return neg + value + getSpaceBetweenSignAndQuantity(currency)
        + getCurrencySymbol(currency);
}

function formatWithCurrencyInFront(neg, value, currency) {
    return (currency.signBetweenSymbolAndValue ? '' : neg) + getCurrencySymbol(currency) +
        getSpaceBetweenSignAndQuantity(currency) + (currency.signBetweenSymbolAndValue ? neg : '') + value;
}

function getCurrencySymbol(currency) {
    return currency.currencySymbolPrefix + currency.currencySign;
}

function getSpaceBetweenSignAndQuantity(currency) {
    return currency.spaceBetweenSignAndQuantity ? ' ' : '';
}

function formatDecimals(qty, decimals, currency) {
    const numberOfDecimals = 2;

    return currency.decimalPlaces > 0
        ? currency.decimalSeparator + Math.abs(qty - decimals).toFixed(currency.decimalPlaces).slice(numberOfDecimals)
        : '';
}

function formatThousands(decimals, currency) {
    const separator = currency.thousandSeparator;
    const thousandsRegex = /(\d{3})(?=\d)/g;
    const digitsBeforeFirstThousand = decimals.length > 3 ? decimals.length % 3 : 0;
    const firstPart = digitsBeforeFirstThousand ? decimals.substr(0, digitsBeforeFirstThousand) + separator : '';
    const lastPart = decimals.substr(digitsBeforeFirstThousand).replace(thousandsRegex, '$1' + separator);

    return firstPart + lastPart;
}

function formatNegationSymbol(qty, currency) {
    return qty < 0 ? currency.negationSymbol : '';
}

function normaliseQuantity(qty, currency) {
    return Math.abs(+qty || 0).toFixed(currency.decimalPlaces);
}

/**
 * Format the currency using a currency model.
 * @param {String|Number} qty - Quantity to be formatted.
 * @param {Object} [currency = Utils.Currency] - Currency model to be used. Param is optional
 * @return {String} The quantity properly formatted according to the Currency model.
 */
Odigeo.Utils.formatCurrency = function(qty, currency) {
    currency = currency || Odigeo.Utils.Currency;
    const neg = formatNegationSymbol(qty, currency);
    qty = normaliseQuantity(qty, currency);
    const value = formatValue(qty, currency);

    return formatValueWithCurrency(neg, value, currency);
};

/**
 * Format the currency using a currency model.
 * @param {String|Number} qty - Quantity to be formatted.
 * @param {Object} [currency = Utils.Currency] - Currency model to be used. Param is optional
 * @return {String} The quantity properly formatted according to the Currency model.
 */
Odigeo.Utils.formatCurrencyWithMarkup = function(qty, currency) {
    currency = currency || Odigeo.Utils.Currency;
    const neg = formatNegationSymbol(qty, currency);
    qty = normaliseQuantity(qty, currency);
    const value = formatValueWithMarkup(qty, currency);

    return formatValueWithCurrency(neg, value, currency);
};
